import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row my-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border fw-bold" }, "Наименование"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, "Состояние"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, "Запчасти (сумма, тг)"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, "Услуги (сумма, тг)"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border fw-bold" }, "Стоимость")
], -1)
const _hoisted_2 = { class: "col-3 border d-flex align-items-center" }
const _hoisted_3 = { class: "col-2 border" }
const _hoisted_4 = { class: "col-2 border" }
const _hoisted_5 = { class: "col-2 border" }
const _hoisted_6 = { class: "col-2 border text-end" }
const _hoisted_7 = {
  key: 0,
  class: "col-1"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "row my-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 border fw-bold" }, "Итого", -1)
const _hoisted_11 = { class: "col-2 border fw-bold" }
const _hoisted_12 = { class: "col-2 border fw-bold" }
const _hoisted_13 = { class: "col-3 border fw-bold" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 text-center" }

import { onMounted, reactive, computed } from 'vue';
  import { DATASHEET_STATE_COLLECTION } from '@depo/constants/project-register';
  import { useModal } from '@/composables/useModal';
  import formatMoney from '@/utils/formatMoney';
  import api from '@/api';
  
  type constructivePriceType = {
    constructiveId: number;
    constructiveName: string;
    constructiveNumber: string;
    projectRegisterId: number;
    totalWithoutVAT: number;
    workAndServicesPrice: number;
    materialsPrice: number;
  };

  type datasheetType = {
    name: string;
    state: string;
    sparePartsTotal?: string;
    servicesTotal?: string;
    comment?: string;
  };
  
  type stateType = {
    constructivePrices: Array<constructivePriceType>;
    datasheets: Array<datasheetType>;
    visibleErrors: boolean;
    loader: boolean;
  };
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRegisterDatasheetModal',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  setup(__props) {

  const props = __props;
  
  const modal = useModal(props.id);
  
  const state: stateType = reactive({
    constructivePrices: [],
    datasheets: [{
      name: '',
      state: '',
      sparePartsTotal: '',
      servicesTotal: '',
      comment: '',
    }],
    visibleErrors: false,
    loader: false,
  });

  function handleAddItemToDatasheet() {
    state.datasheets.push({
      name: '',
      state: '',
      sparePartsTotal: '',
      servicesTotal: '',
      comment: '',
    });
  }

  function handleStateSelect(_c: { id: string }, idx: number) {
    state.datasheets[idx].state = _c.id;
}

  function handleDeleteItemFromDatasheet(idx: number) {
    state.datasheets.splice(idx, 1);
  }

  const calculateTotal = computed(() => (datasheet: datasheetType) => {
    return Number(datasheet.sparePartsTotal) + Number(datasheet.servicesTotal)
  });

  const totalOfServices = computed(() => {
    return state.datasheets.reduce((acc, datasheet) => acc + Number(datasheet.servicesTotal), 0);
  });

  const totalOfSpareParts = computed(() => {
    return state.datasheets.reduce((acc, datasheet) => acc + Number(datasheet.sparePartsTotal), 0);
  });

  const isStateError = computed(() => (datasheet: datasheetType) => !datasheet.state);
  const isTotalError = computed(() => (datasheet: datasheetType) => !datasheet.sparePartsTotal || !datasheet.servicesTotal);

  const isNameError = computed(() => (datasheet: datasheetType) => {
    return !datasheet.name;
  })
  
  const errors = computed(() => state.datasheets.some((cp) => isNameError.value(cp)));
  
  onMounted(() => {
    api.projectRegister.getDatasheet(+modal.data.projectRegister.id).then(response => {
      if (response.data?.length) {
        state.datasheets = response.data.map((datasheet: datasheetType) => ({
          name: datasheet.name,
          state: datasheet.state,
          sparePartsTotal: datasheet.sparePartsTotal,
          servicesTotal: datasheet.servicesTotal,
          comment: datasheet.comment,
        }));
      }
    }).catch(console.error);

  
  });
  
  function send() {
    if (errors.value) {
      state.visibleErrors = true;
      return;
    }
    state.visibleErrors = false;
    state.loader = true;
  
    api.projectRegister.saveDatasheet(modal.data.projectRegister.id, { datasheets: state.datasheets })
      .then(() => modal.ok({ isSuccess: true }))
      .finally(() => (state.loader = false));
  }
  
return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-xl",
    title: "Техническое состояние"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _hoisted_1,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.datasheets, (datasheet, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row my-2",
            key: idx
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите наименование",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2",
                    modelValue: datasheet.name,
                    "onUpdate:modelValue": ($event: any) => ((datasheet.name) = $event),
                    "is-invalid": state.visibleErrors && isNameError.value(datasheet)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите состояние",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": state.visibleErrors && isStateError.value,
                    options: _unref(DATASHEET_STATE_COLLECTION).map(c => ({ name: c, id: c })),
                    placeholder: "Состояние",
                    values: [datasheet.state],
                    onOnUpdated: (s) => handleStateSelect(s, idx)
                  }, null, 8, ["is-invalid", "options", "values", "onOnUpdated"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите ремонт или замену",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2",
                    modelValue: datasheet.servicesTotal,
                    "onUpdate:modelValue": ($event: any) => ((datasheet.servicesTotal) = $event),
                    "is-invalid": state.visibleErrors && isNameError.value(datasheet)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_form_group_ui, { "invalid-feedback": "Введите сумму запчастей" }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2",
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } },
                    maxlength: "12",
                    "is-invalid": state.visibleErrors && isTotalError.value,
                    placeholder: "",
                    modelValue: datasheet.sparePartsTotal,
                    "onUpdate:modelValue": ($event: any) => ((datasheet.sparePartsTotal) = $event)
                  }, null, 8, ["is-invalid", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatMoney)(calculateTotal.value(datasheet))), 1),
            (state.datasheets.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-sm d-flex justify-content-center align-items-center",
                    onClick: ($event: any) => (handleDeleteItemFromDatasheet(idx))
                  }, [
                    _createVNode(_component_vue_feather, {
                      size: "14px",
                      type: "x"
                    })
                  ], 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formatMoney)(totalOfServices.value)), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(formatMoney)(totalOfSpareParts.value)), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatMoney)(totalOfServices.value + totalOfSpareParts.value)), 1)
        ]),
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-1" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary d-flex justify-content-center align-items-center",
              onClick: handleAddItemToDatasheet
            }, " Добавить поле ")
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})